import React from "react";
import { Typography, Box } from "@mui/material";
import "./About.css"; // Ensure this file exists

const About = () => {
  return (
    <div className="about-container">
      <Box className="about-content">
        <Typography variant="h3" className="about-title" gutterBottom>
          About Us
        </Typography>
        <Typography variant="body1" className="about-text" paragraph>
          At <span className="highlight">CaRE Constructions</span>, we specialize in building 
          residential houses and luxury villas with an unwavering focus on 
          quality, safety, and sustainability. As a division of 
          <span className="highlight"> Capital Re Energy and Laboratory Pvt Ltd</span>, we go beyond 
          construction—we ensure structural integrity through comprehensive material 
          testing and soil analysis, all included in your cost.
        </Typography>
        <Typography variant="body1" className="about-text" paragraph>
          With a <span className="highlight">16-year structural guarantee</span>, we offer not just 
          a home but a commitment to durability and peace of mind. Our expert team 
          of architects, engineers, and project managers ensures every project is 
          completed on time, within budget, and with the highest standards.
        </Typography>

        <Box className="about-list">
          <Typography variant="h5" className="about-subtitle" gutterBottom>
            Why Choose CaRE Constructions?
          </Typography>
          <ul>
            <li>✔ <strong>Superior Construction Quality</strong> – Backed by in-house material testing</li>
            <li>✔ <strong>Foundation & Soil Testing Included</strong> – Ensuring long-term structural integrity</li>
            <li>✔ <strong>Sustainable & Energy-Efficient Homes</strong> – Future-proof and cost-effective solutions</li>
            <li>✔ <strong>16-Year Structural Guarantee</strong> – Peace of mind long after handover</li>
            <li>✔ <strong>On-Time Project Completion</strong> – Efficient execution without compromise</li>
          </ul>
        </Box>
      </Box>
    </div>
  );
};

export default About;
